import React from 'react';
import { useSponsorROI } from "../query/hooks";
import { Spinner } from "reactstrap";

const ROIWidget = ({ sponsorObjectId, usePaValue = false, rightsholderId = 0, parentTenantId = null, tracked = false }) => {
  const { data: roiData, isFetching } = useSponsorROI(sponsorObjectId, { usePaValue, rightsholderId, parentTenantId, tracked });

  const formatPercentage = (value, trend) => {
    const sign = trend >= 0 ? '+' : '-';
    return `${sign}${(value * 100).toFixed(1)}%`;
  };

  if (isFetching || !roiData) {
    return <div className="d-flex justify-content-center pt-3"><Spinner color="primary" /></div>;
  }

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="d-flex justify-content-center align-items-end" style={{ marginBottom: '1.5rem' }}>
        <span style={{ fontSize: '3rem', fontWeight: 700, lineHeight: 1, color: 'var(--text-primary)' }}>
          x{roiData.roi.toFixed(2)}
        </span>
        <span
          className={roiData.trend >= 0 ? 'text-success' : 'text-danger'}
          style={{ marginLeft: '0.5rem', marginBottom: '0.25rem', fontSize: '0.9rem' }}
        >
          {formatPercentage(Math.abs(roiData.trend), roiData.trend)}
        </span>
      </div>

      <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '0.75rem' }}>
        {roiData.series.map((item, index) => (
          <div key={index} style={{ display: 'grid', gridTemplateColumns: '1fr auto auto', gap: '0.75rem', alignItems: 'center', marginBottom: '0.75rem' }}>
            <div style={{ color: 'var(--text-primary)', fontSize: '0.85rem', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {item.sponsor_object}
            </div>
            <div style={{ color: 'var(--text-primary)', fontSize: '0.85rem', textAlign: 'right', whiteSpace: 'nowrap' }}>
              x{item.roi.toFixed(2)}
            </div>
            <div style={{ fontSize: '0.85rem', textAlign: 'right', whiteSpace: 'nowrap', minWidth: '3.5rem' }}
              className={item.trend >= 0 ? 'text-success' : 'text-danger'}>
              {formatPercentage(Math.abs(item.trend), item.trend)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ROIWidget;